import { render, staticRenderFns } from "./CreateItemsModal.vue?vue&type=template&id=1a9a00e7&scoped=true&"
import script from "./CreateItemsModal.vue?vue&type=script&lang=js&"
export * from "./CreateItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateItemsModal.vue?vue&type=style&index=0&id=1a9a00e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a00e7",
  null
  
)

export default component.exports